export default __webpack_public_path__ + "static/media/media-dummy.a47ea79a.png";